import * as yup from "yup";
export const T4ASummarySetupSchema = yup.object().shape({
  registrationNumbersForRppOrDscp071: yup.string().max(9,"Maximum 7 characters required!"),
  registrationNumbersForRppOrDscp072: yup.string().max(9,"Maximum 7 characters required!"),
  registrationNumbersForRppOrDscp073: yup.string().max(9,"Maximum 7 characters required!"),
});
